import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Footer = () => {
  const [contactInfo, setContactInfo] = useState({
    address: '123 Logistics Avenue',
    city: 'Business District',
    phone_primary: '+1 (555) 123-4567',
    email_primary: 'info@intqualitygroup.com',
    facebook_url: '#',
    twitter_url: '#',
    linkedin_url: '#',
    instagram_url: '#',
  });

  useEffect(() => {
    const fetchContactInfo = async () => {
      try {
        const response = await axios.get(`${API}/contact/contact-info`);
        setContactInfo(response.data);
      } catch (error) {
        console.error('Failed to fetch contact info:', error);
      }
    };
    fetchContactInfo();
  }, []);

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <img 
              src="/logo.png" 
              alt="International Quality Group" 
              className="h-10 w-auto mb-4"
            />
            <p className="text-sm text-gray-400">
              Your trusted partner in international shipping and last-mile delivery solutions.
            </p>
            <div className="flex space-x-4">
              {contactInfo.facebook_url && contactInfo.facebook_url !== '#' && (
                <a href={contactInfo.facebook_url} target="_blank" rel="noopener noreferrer" className="inline-flex hover:text-emerald-500 hover:-translate-y-0.5 transition-all">
                  <Facebook size={20} />
                </a>
              )}
              {contactInfo.twitter_url && contactInfo.twitter_url !== '#' && (
                <a href={contactInfo.twitter_url} target="_blank" rel="noopener noreferrer" className="inline-flex hover:text-emerald-500 hover:-translate-y-0.5 transition-all">
                  <Twitter size={20} />
                </a>
              )}
              {contactInfo.linkedin_url && contactInfo.linkedin_url !== '#' && (
                <a href={contactInfo.linkedin_url} target="_blank" rel="noopener noreferrer" className="inline-flex hover:text-emerald-500 hover:-translate-y-0.5 transition-all">
                  <Linkedin size={20} />
                </a>
              )}
              {contactInfo.instagram_url && contactInfo.instagram_url !== '#' && (
                <a href={contactInfo.instagram_url} target="_blank" rel="noopener noreferrer" className="inline-flex hover:text-emerald-500 hover:-translate-y-0.5 transition-all">
                  <Instagram size={20} />
                </a>
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm hover:text-emerald-500 transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-sm hover:text-emerald-500 transition-colors">About Us</Link></li>
              <li><Link to="/services" className="text-sm hover:text-emerald-500 transition-colors">Services</Link></li>
              <li><Link to="/contact" className="text-sm hover:text-emerald-500 transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2">
              <li><Link to="/services" className="text-sm hover:text-emerald-500 transition-colors">International Shipping</Link></li>
              <li><Link to="/services" className="text-sm hover:text-emerald-500 transition-colors">Last-Mile Delivery</Link></li>
              <li><Link to="/services" className="text-sm hover:text-emerald-500 transition-colors">Freight Forwarding</Link></li>
              <li><Link to="/services" className="text-sm hover:text-emerald-500 transition-colors">Supply Chain Solutions</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin size={18} className="text-emerald-500 mt-1 flex-shrink-0" />
                <span className="text-sm">{contactInfo.address}, {contactInfo.city}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone size={18} className="text-emerald-500 flex-shrink-0" />
                <span className="text-sm">{contactInfo.phone_primary}</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail size={18} className="text-emerald-500 flex-shrink-0" />
                <span className="text-sm">{contactInfo.email_primary}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">
            &copy; {new Date().getFullYear()} International Quality Group. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;